/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getLoginPage = (): Layout => ({
	name: 'AuthStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'LoginBanner', id: 'login-banner' }],
		second: [{ name: 'Login', id: 'login' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
